import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';
import AppService from 'App/legacy/AppService';

export default function updateAppointments(rb: RequestBuilder, entity: string, multiSelect: MultiSelect) {
	const opts = {
		customerId: AppService.getCustomerId(),
		filters: rb,
		hideDate: false,
		entity,
		multiSelect
	};
	return openModal('MultiUpdateAppointmentModal', opts);
}
